import React from 'react'
import {Grid, Header} from "semantic-ui-react";
import Plot from "../../node_modules/react-plotly.js/react-plotly";
import '../style.css'

function Statistics(
    {
        students,
        pronunciationViewCount,
        dialogConversationViewCount,
        translationViewCount,
        dialogFlashCardViewCount,
        quizzesViewCount,
        dates,
        totalViewCount,
        todaysViews,
    }
) {
    return (
        <>
            <br/>

            <div className='statisticsStyle'>
            <Grid centered={true} >
                <Grid.Row>
                    <Header as='h1'>
                        Student Views
                    </Header>
                </Grid.Row>
                <Grid.Row columns={3}>
                    <Grid.Column>
                    <Plot
                        data={[
                            {
                                x: dates,
                                y: totalViewCount,
                                name: 'Attacks/Day',
                                type: 'scatter',
                                mode: 'lines+markers',
                                marker: {color: 'blue'},
                            }
                        ]}
                        layout={{
                            width: 600,
                            height: 450,
                            autoSize: true,
                            title: 'View Count for Today: ' + todaysViews,
                            xaxis: {
                                title: {
                                    text: 'Date',
                                    font: {
                                        size: 18,
                                        color: 'black'
                                    }
                                },
                                tickangle: -45,
                            },
                            yaxis: {
                                title: {
                                    text: '# of views',
                                    font: {
                                        size: 18,
                                        color: 'black'
                                    }
                                }
                            },
                        }}
                    />
                    </Grid.Column>
                    <Grid.Column>
                        <Plot
                            data={[
                                {
                                    type: 'table',
                                    header: {
                                        values: [["<b>Student</b>"], ["<b>PronunciationWrapper</b>"],
                                            ["<b>Dialog Conversation</b>"], ["<b>Translation Flash Cards</b>"], ["<b>Dialog Flash Cards</b>"], ["<b>Translation Quiz</b>"]],
                                        align: "center",
                                        line: {width: 4, color: 'black'},
                                        fill: {color: "black"},
                                        font: {family: "Arial", size: 15, color: "white"}
                                    },
                                    cells: {
                                        values: [students, pronunciationViewCount, dialogConversationViewCount, translationViewCount, dialogFlashCardViewCount, quizzesViewCount],
                                        align: "right",
                                        line: {color: "black", width: 1},
                                        font: {family: "Arial", size: 13, color: ["black"]},
                                        fill: {color: ["white"]}
                                    }
                                },
                            ]}
                            layout={{
                                width: 720,
                                height: 450,
                                autoSize: true,
                                title: 'Page View Count',

                            }}
                        />
                    </Grid.Column>
                </Grid.Row>
            </Grid>
            </div>
        </>
    )

}

export default Statistics
